export enum ThinConferenceSort {
  ExtendedName = 'extended_name',
}
